import React from 'react';
import { JointPill } from './TriageListPage.styles';

const SelectedJointsCell: React.FC<{ appointment: any }> = ({ appointment }) => {
    const fromSummary = (appointment?.exam_summary?.selected_joints as string[] | undefined) || [];

    // Fallback to legacy ranking map if new summary not present
    const jointsRankMap = appointment?.joints || {};
    const fromLegacy = Object.entries(jointsRankMap)
        .filter(([, v]: any) => !!v)
        .sort((a: any, b: any) => (a[1] || 0) - (b[1] || 0))
        .map(([k]: any) => k);

    const list: string[] = (fromSummary.length ? fromSummary : fromLegacy).slice(0, 4);

    if (!list.length) return <span>-</span>;

    const toAbbrev = (fullJoint: string) => {
        const [side, joint] = fullJoint.split(' ');
        const sideLetter = (side || '')[0]?.toUpperCase() || '';
        const jointLetter = (joint || '')[0]?.toUpperCase() || '';
        return `${sideLetter}${jointLetter}`;
    };

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {list.map((fullJoint: string) => (
                <JointPill key={fullJoint}>{toAbbrev(fullJoint)}</JointPill>
            ))}
        </div>
    );
};

export default SelectedJointsCell;


